/**
 * "Add a card": every card type the caller may see. Choosing one adds it at
 * the end with the type's default config; the page then opens its settings,
 * when it has any.
 */
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { MODULE_NAMESPACES } from '../../modules/locales';
import type { CatalogueEntry } from './layout';

export interface AddCardDialogProps {
  open: boolean;
  types: readonly CatalogueEntry[];
  onAdd: (entry: CatalogueEntry) => void;
  onClose: () => void;
}

export function AddCardDialog({ open, types, onAdd, onClose }: AddCardDialogProps) {
  const { t } = useTranslation(['system', 'common', ...MODULE_NAMESPACES]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{t('system:dashboard.addCardTitle')}</DialogTitle>
      <List sx={{ pt: 0 }}>
        {types.map((entry) => {
          const Icon = entry.type.icon;
          return (
            <ListItemButton key={entry.key} onClick={() => onAdd(entry)}>
              <ListItemIcon>
                <Icon />
              </ListItemIcon>
              <ListItemText primary={t(entry.type.titleKey)} />
            </ListItemButton>
          );
        })}
      </List>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>{t('common:action.cancel')}</Button>
      </DialogActions>
    </Dialog>
  );
}
